/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Base64 from 'base-64';

const LinkOrSpan = ({ displayLink: displayLinkProps, children, href, className, ...others }, { displayLink: displayLinkContext }) => {
  // On regarde si le lien est à afficher, en priorité dans les props, sinon dans le context
  let displayLink = true;
  if (displayLinkProps !== undefined) {
    displayLink = displayLinkProps;
  } else if (displayLinkContext !== undefined) {
    displayLink = displayLinkContext;
  }

  return (displayLink
    ? (
      <a {...others} href={href} className={className || undefined}>
        {children}
      </a>
    ) : (
      <span {...others} data-ol={Base64.encode(href)} className={`${className} pointer`}>
        {children}
      </span>
    )
  );
};

LinkOrSpan.propTypes = {
  displayLink: PropTypes.bool,
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
};

LinkOrSpan.defaultProps = {
  displayLink: undefined,
  className: '',
};

LinkOrSpan.contextTypes = {
  displayLink: PropTypes.bool,
};

export default LinkOrSpan;
